import { WarningOutlined } from "@ant-design/icons";
import { Input as AntdInput } from "antd";
import cx from "classnames";
import { useField } from "formik";
import { isNil } from "lodash";
import get from 'lodash/get';
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import styles from "./Input.module.css";

const InputForm = ({
  label = "",
  name = "",
  placeholder = "",
  type = "text",
  size = "middle",
  onChange = () => { },
  className = "",
  subclassName = "",
  required = false,
  disabled = false,
  useTimeout = null,
  autoSize = false,
  autoComplete = "",
  onKeyDown = () => { },
  rows = "8",
  readOnly = false,
  regex = '',
  formRegex = false,
  errors,
  touched
}) => {
  const { i18n } = useTranslation();
  const [timeoutId, setTimeoutId] = useState(null);
  const [field, meta, helpers] = useField(name);
  const { onBlur } = field;
  const { value } = meta;
  const { setValue } = helpers;
  const hasError = get(errors, name)
  const handleChange = (e) => {
    let value;
    if (regex && formRegex) {
      if (regex.test(e.target.value)) {
        value = e.target.value;
        onChange(value)
      } else {
        onChange('')
        return;
      }
    } else {
      value = e.target.value
    }
    setValue(value);
    if (useTimeout) {
      if (timeoutId) clearTimeout(timeoutId);
      setTimeoutId(
        setTimeout(() => {
          onChange(value);
        }, useTimeout)
      );
    } else {
      onChange(value);
    }
  };

  const translatedError = i18n?.language === "th"
    ? `กรุณาเลือก ${label}`
    : `Please enter ${label?.toLowerCase?.()}`

  useEffect(() => {
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  return (
    <div className={cx(styles.container, className)}>
      {label && (
        <label className={cx("label", styles.label)} htmlFor={name}>
          {label}
          {required && <span className="error">*</span>}
        </label>
      )}
      {type === "password" ? (
        <AntdInput.Password
          id={name}
          readOnly={readOnly}
          className={cx(styles.input, subclassName)}
          name={name}
          placeholder={placeholder}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && hasError ? "error" : ""}
          status={touched && hasError ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          autoComplete={autoComplete}
        />
      ) : type === "text" ? (
        <AntdInput
          id={name}
          className={cx(styles.input, subclassName)}
          readOnly={readOnly}
          name={name}
          placeholder={placeholder}
          type={type}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && hasError ? "error" : ""}
          status={touched && hasError ? "error" : ""}
          disabled={disabled}
          data-type={type}
          size={size}
          autoComplete={autoComplete}
        />
      ) : (
        <AntdInput.TextArea
          rows={rows}
          readOnly={readOnly}
          autoSize={autoSize}
          id={name}
          className={cx(styles.input, subclassName)}
          name={name}
          placeholder={placeholder}
          value={value || ""}
          onChange={handleChange}
          onBlur={onBlur}
          data-state={touched && hasError ? "error" : ""}
          status={touched && hasError ? "error" : ""}
          disabled={disabled}
          size={size}
          autoComplete={autoComplete}
          onKeyDown={onKeyDown}
        />
      )}

      {touched && hasError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {!isNil(hasError) ? hasError : translatedError}
        </span>
      )}
    </div>
  );
};

export default InputForm;
